import { generatePath } from 'react-router'

export const endpoints = {
    programsList: (uuid: string): string => generatePath('recommended/company/:uuid/recommended-programs/', { uuid }),
    saveProgram: (uuid: string): string => generatePath('recommended/company/:uuid/save-program/', { uuid }),
    deleteProgram: (uuid: string, id: number): string =>
        generatePath('recommended/company/:uuid/delete-program/:id/', { uuid, id }),
    changeProgramStatus: (uuid: string): string =>
        generatePath('recommended/company/:uuid/change-program-status/', { uuid }),
}
